var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageHeadingBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 417,
    viewBox: "0 0 1439 417",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1 0H1427.01V417L-1 395.053V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6620_12243",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 1440,
    height: 417
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 0H1439V417L-1 395.053V0Z",
    fill: "#016170"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6620_12243)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter0_f_6620_12243)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -1,
    cy: 208.5,
    rx: 261,
    ry: 127.295,
    fill: "#000B0C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter1_f_6620_12243)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.8,
    cy: 24.581,
    rx: 261,
    ry: 127.295,
    fill: "#002227"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter2_f_6620_12243)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1351.7,
    cy: 175.579,
    rx: 193.5,
    ry: 94.3737,
    fill: "#D78A39"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6620_12243",
    x: -562,
    y: -218.795,
    width: 1122,
    height: 854.589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_6620_12243"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6620_12243",
    x: -317.2,
    y: -402.714,
    width: 1122,
    height: 854.589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_6620_12243"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_6620_12243",
    x: 858.2,
    y: -218.795,
    width: 987,
    height: 788.747,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_6620_12243"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageHeadingBg);
export default __webpack_public_path__ + "static/media/page-heading-bg.10a2b7812bde418850c26d762dddd22a.svg";
export { ForwardRef as ReactComponent };